import { useContext, useEffect } from "react";
import debugContext from "@lib/contexts/debug";

// Adds support for debug key (` / ~)
function DebugKey({ children }: { children: JSX.Element }): JSX.Element {
  const { debugMode, setDebugMode } = useContext(debugContext);

  // Add debug key support
  useEffect(() => {
    function handleDebugKey(e: KeyboardEvent) {
      if ((e.key == "`" || e.key == "~") && e.target == document.body) {
        const newDebugMode = !debugMode;
        setDebugMode(newDebugMode);
        window.debugContent = newDebugMode;
      }
    }

    document.addEventListener("keydown", handleDebugKey);
    return () => document.removeEventListener("keydown", handleDebugKey);
  }, [debugMode, setDebugMode]);

  return children;
}

export default DebugKey;
